var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn btn-modal btn-md text-capitalize",attrs:{"to":{ path: _vm.item.id },"append":""}},[_vm._v(" View ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }